export const MOBILE_OPTION_HEIGHT = 32;
export const MOBILE_VISIBLE_OPTIONS = 7;
export const MOBILE_PICKER_HEIGHT = MOBILE_OPTION_HEIGHT * MOBILE_VISIBLE_OPTIONS;
export const MOBILE_SCROLL_SETTLE_DELAY = 140;
export const MOBILE_WHEEL_BUFFER_OPTIONS = 3;
